<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <footer class="knowledge-test__footer">
    <div class="knowledge-test__progress">
      <div>
        <i18n-t keypath="Отвечено {answered} из {total}" tag="span">
          <template #answered
            ><b>{{ answered }}</b></template
          >
          <template #total>{{ total }}</template>
        </i18n-t>
        <span>{{ message }}</span>
      </div>
      <progress
        :value="answered"
        :max="total"
        :aria-label="$t('Отвечено {answered} из {total}', { answered, total })"
      ></progress>
    </div>
    <button type="submit" class="knowledge-test__button" :disabled="disabled">
      {{ $t(submitting ? "Отправка…" : "Завершить тест") }}
    </button>
  </footer>
</template>
